import React from 'react';
import * as S from './ListingBlock.styles';

const ThankYouListingBlock = ({listData, title}) => (
  <S.Wrapper>
    <S.BlkcHead>{title}</S.BlkcHead>
    {/* <S.CancelPolicyWarningText>Note: The hotelier may cancel / deny check-in if the below rules are not followed. </S.CancelPolicyWarningText> */}
    <S.ListWrap>
      {listData.map((policy, i) => <li key={`policy${i}`}>{policy}</li>)}
    </S.ListWrap>
  </S.Wrapper>
);

export default ThankYouListingBlock;
